/**
 * 主题
 */
export const AppPlatformEnums = {
  GT: "GT",
  GR: "GR"
};
export const ThemeNameEnums = {
  GT: "platform-theme-gt",
  GR: "platform-theme-gr"
};



// WEBPACK FOOTER //
// ./src/utils/enum.js